module.exports = __webpack_public_path__ + "0f800e0bf1f5fd06c8b358641c33920e.pdf";